// extracted by mini-css-extract-plugin
export default {"chipContainer":"styles_chipContainer__7lQbe","chipContente":"styles_chipContente__geM2U"};